module.exports = __webpack_public_path__ + "components/MapControl/svg/Przejście graniczne.svg?d95ea608";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Przejście graniczne.svg
// module id = 1982
// module chunks = 0